import { XdrSearchWebComponent } from './component/XdrSearchWebComponent';
import { WEB_COMPONENT_XDR_SEARCH_APP } from '../../webcomponents.constants';

export { XdrSearchWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_SEARCH_APP, XdrSearchWebComponent);
